module.exports = __webpack_public_path__ + "static/media/noWaves.441ca8f7.png";